import { jsx as _jsx } from "react/jsx-runtime";
import SSIAddIcon from '../../assets/icons/SSIAddIcon';
import SSIFilterIcon from '../../assets/icons/SSIFilterIcon';
import SSIArrowDownIcon from '../../assets/icons/SSIArrowDownIcon';
import { ButtonIconsEnum } from '../../../types';
import { SSIIconButtonContainerStyled as Container } from '../../../styles/components';
import { fontColors } from '@sphereon/ui-components.core';
const SSIIconButton = (props) => {
    const { icon, onClick, disabled = false, color = fontColors.dark } = props;
    return _jsx(Container, { onClick: onClick, children: getIcon(icon, color) });
};
const getIcon = (icon, color) => {
    switch (icon) {
        case ButtonIconsEnum.ADD:
            return _jsx(SSIAddIcon, { color: color });
        case ButtonIconsEnum.FILTER:
            return _jsx(SSIFilterIcon, { color: color });
        case ButtonIconsEnum.ARROW_DOWN:
            return _jsx(SSIArrowDownIcon, { color: color });
        default:
            return _jsx("div", {});
    }
};
export default SSIIconButton;
